prodUrl = "https://api.phocus1.com/api";
prodGoogleAuthUrl = "https://api.phocus1.com/auth/google";

devUrl = "https://testapi.phocus1.com/api";
devGoogleAuthUrl = "https://testapi.phocus1.com/auth/google";


module.exports = global.config = {
  server_url: devUrl,
  google_auth_url: devGoogleAuthUrl,
  maintenance: false,
  // Yousign relay : URL du webhook n8n "create" (navigateur → n8n)
  // Dev/test : webhook-test (pas besoin d'activer le workflow)
  // Prod     : remplacer par https://n8n.srv796541.hstgr.cloud/webhook/yousign-create
  n8n_yousign_create_url: "https://n8n.srv796541.hstgr.cloud/webhook-test/yousign-create",
};
